<div
  class="no-data"
  [ngClass]="{
    'no-data-compact': variant === 'compact',
    'no-data-bordered': variant === 'bordered',
    'no-data-minimal': variant === 'minimal',
  }"
>
  @if (appicon) {
    <div class="empty-state-icon">
      <app-icon [name]="appicon" [size]="appsize" [color]="appcolor"></app-icon>
    </div>
  }

  <h3 class="no-data-title">
    <span>{{ message }}</span>
  </h3>

  <span class="no-data-description">
    <span>{{ description }}</span>
  </span>
  @if (buttontext) {
    <button class="btn btn-primary" (click)="onClick()">
      @if (buttonicon) {
        <app-icon [name]="buttonicon" [size]="12"></app-icon>
      }
      {{ buttontext }}
    </button>
  }
</div>
